const common = require("lib/labels/_common");

// Home.platform.services

module.exports = {
  apiList: {
    title: {
      en: "APIs",
      fr: "APIs"
    },
    title_delete_check: common.title_delete_check,
    content_delete_check: common.content_delete_check,
    no: common.no,
    yes: common.yes,
    edit: common.edit,
    remove: {
      en: "Remove",
      fr: "Supprimer"
    },
    detailed: {
      name: {
        en: "Name",
        fr: "Nom"
      },
      appName: {
        en: "App",
        fr: "App"
      },
      appVersion: {
        en: "App's version",
        fr: "Version de l'application"
      },
      service: {
        en: "Database",
        fr: "Base de donnée"
      },
      endpoints: {
        en: "Endpoints",
        fr: "Points d'entrée"
      }
    }
  },
  apiForm: {
    stepTitle: {
      en: "API",
      fr: "API"
    },
    title: {
      creation: {
        en: "New API",
        fr: "Nouvel API"
      },
      edition: {
        en: "Edit API",
        fr: "Edition d'API"
      }
    },
    name: common.name,
    key: {
      en: "API key",
      fr: "Clé de l'API"
    },
    service: {
      en: "Service",
      fr: "Service"
    },
    entities: {
      en: "Entities",
      fr: "Entités"
    },
    libraries: {
      en: "Libraries",
      fr: "Librairies"
    },
    public: {
      en: "Public",
      fr: "Publique"
    },
    price: {
      en: "Price",
      fr: "Prix"
    },
    select_all: {
      en: "Check all",
      fr: "Tout cocher"
    },
    deselect_all: {
      en: "Uncheck all",
      fr: "Tout décocher"
    },
    errName: {
      en: ""
    },
    testName: {
      en: "This name already exists",
      fr: "Nom déjà utilisé"
    },
    testKey: {
      en: "Characters not allowed",
      fr: "Caractère(s) non autorisé(s)"
    },
    keyAlreadyExisting: {
      en: "This key already exists",
      fr: "Clé déjà utilisé"
    }
  }
};
